import EndUrls from "../endUrls";
import { patchService } from "../services";

export const changeStatus = async ({ id, status }) => {
   try {
      const data = {
         vendor_master_id: id,
         is_active: status,
         model_id: 7,
         action_id: 2,
      };

      const { data: res } = await patchService(EndUrls.changeVendorStatus, data, true);

      if (res.statusCode === 200) {
         return res;
      } else {
         throw new Error(res.message);
      }
   } catch (error) {
      throw error;
   }
};
